module.exports = __webpack_public_path__ + "static/media/06.6c067d51.jpg";